import { withInstall } from '@tav-ui/utils/with-install'
import Icon from './src/icon.vue'
const TaIcon = withInstall(Icon)
export { TaIcon }
export default TaIcon
